import { render, staticRenderFns } from "./Amazon.vue?vue&type=template&id=00abcb79&"
import script from "./Amazon.vue?vue&type=script&lang=js&"
export * from "./Amazon.vue?vue&type=script&lang=js&"
import style0 from "./Amazon.vue?vue&type=style&index=0&id=00abcb79&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports